import React, { useState } from 'react';
import { Spinner } from 'ui';
import addModifiers from 'utils/add_modifiers';
import ConfirmationModal from './ConfirmationModal';

const UpdateButton = ({
  unassignedUserCount,
  loading,
  confirmGroupTriggerUpdate,
  onClick,
}) => {
  const [showModal, updateShowModal] = useState(false);

  const handleUpdate = (params = {}) => {
    if (loading) return;

    if (confirmGroupTriggerUpdate && !showModal) {
      updateShowModal(true);
    } else {
      onClick(params);
    }
  };

  return (
    <>
      <button
        type="submit"
        onClick={() => handleUpdate()}
        className={`h-td-n fz-base
          ${addModifiers('CustomColor', ['backgroundColor', 'buttonBoxShadow'])}
          ${addModifiers('NewButton', ['yellow', 'tallAndWide'])}
        `}
      >
        {loading && <Spinner color="darker" className="mr-8" />}
        {t('triggers.labels.update')}
      </button>
      {showModal && (
        <ConfirmationModal
          unassignedUserCount={unassignedUserCount}
          loading={loading}
          onConfirm={handleUpdate}
          onDismiss={() => updateShowModal(false)}
        />
      )}
    </>
  );
};

export default UpdateButton;
